import { Type, type Static } from '@sinclair/typebox';
import { MinimalUser, minimalUserSchema } from '../../shared/user/user.schema';
import { StringEnum } from '../../utils/typebox';

export const relationRequestSchema = Type.Object({
  object: Type.Literal('RelationRequest'),
  user: Type.Optional(
    Type.Object(minimalUserSchema, { description: 'The user who is the target of the relation / follow request.' }),
  ),
  type: StringEnum(['sent', 'received'], {
    description: `Type of the relation / follow request.
      - \`sent\` if the current user has asked another one to be in his relations.
      - \`received\` if another user has asked the current one to be in his relations.`,
  }),
  id: Type.String({ description: 'The unique identifier of the invitation for the provider.' }),
  created_at: Type.Optional(Type.String({ description: 'Uses ISO 8601 UTC datetime (YYYY-MM-DDTHH:MM:SS.sssZ).' })),
  message: Type.Optional(Type.String({ description: 'Any message that comes with the invitation.' })),
});

export type RelationRequest<UserSpecifics = unknown> = Omit<Static<typeof relationRequestSchema>, 'user'> & {
  user?: MinimalUser<UserSpecifics>;
};
